<template>
	<Page>
		<template #header>Import</template>
		<template #default>
			<textarea
				v-model="mnemonic"
				rows="5"
				placeholder="input seed phrase"
				:class="{ 'error-border': error }"
				@blur="handler"
			></textarea>

			<div class="error">{{ error }}</div>
		</template>
		<template #footer>
			<ButtonMain :disabled="!isValid" @click="importWallet()">Import</ButtonMain>
		</template>
	</Page>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { libs, seedUtils } from '@waves/waves-transactions';
import { useWalletStore } from '@/stores/useWalletStore';
import { useRouter } from 'vue-router';
import ButtonMain from '@/components/ui/BaseButton.vue';
import Page from '@/components/ui/Page.vue';

const { addWallet } = useWalletStore();
const router = useRouter();

const mnemonic = ref('');
const error = ref();
const isValid = ref(false);

const handler = (e: FocusEvent) => {
	// if (mnemonic.value.split(' ').length != 15) {
	// 	error.value = 'seed has 15 words';

	// 	isValid.value = false;

	// 	return;
	// }

	// const invalidWord = mnemonic.value.split(' ').reduce((prev, word) => {
	// 	return !libs.crypto.seedWordsList.includes(word) ? word : '';
	// }, '');

	// if (invalidWord) {
	// 	error.value = `seed have incorrect word ${invalidWord}`;

	// 	isValid.value = false;

	// 	return;
	// }

	try {
		seedUtils.Seed.fromExistingPhrase(mnemonic.value);

		error.value = null;

		isValid.value = true;
	} catch (e: any) {
		isValid.value = false;
		error.value = e.toString();
	}
};

const importWallet = () => {
	try {
		addWallet(mnemonic.value);
		router.replace('/');
	} catch (e) {
		error.value = `${e}`;
	}
};
</script>
